import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const ultraSoundImageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUltraSoundImage: builder.query({
      query: () => {
        const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/Patient/ultrasound-images`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetUltraSoundImageQuery } = ultraSoundImageApi;
export default ultraSoundImageApi;
